.options-grid{display:grid;grid-template-columns:1fr 1fr}
/*# sourceMappingURL=position-on-the-number-line.component-23CFW6BX.css.map */
